<template>
  <div class="view login">
        <loader v-if="loading"/>
        <div class="view-content" v-else>
          <div class="container">
            <div class="view-content">
                <a
                  href="/"
                  class="btn"
                >
                    {{ $t('404.cta') }}
                    <sprite
                        :type="'arrow-right'"
                        :width="19"
                        :height="12"
                    />
                </a>
                <h1 class="view-content-title h1">
                    {{ terms.privacy_policy_title }}
                </h1>
                <div class="view-content-text typeset" v-html="terms.privacy_policy_text"></div>
            </div>
          </div>
        </div>
  </div>
</template>

<script>
import Loader from '@/components/components/Loader.vue';
import Sprite from '@/components/components/Sprite.vue';

export default {
  components: {
    Sprite,
    Loader
  },
  beforeMount() {
    const { locale } = this.$route.params;
    if (!this.$store.state.terms.item) {
      this.$store.dispatch('terms/get', locale);
    }
  },
  computed: {
    lang() {
      const lang = localStorage.getItem('lang') || 'ko';
      return lang;
    },
    terms() {
      return this.$store.state.terms.item;
    },
    loading() {
      return this.$store.state.terms.requests !== 0;
    },
  },
  watch: {
    $route(newRoute) {
      const { locale } = newRoute.params;
      this.$store.dispatch('terms/get', locale);
    },
  }
};
</script>

<style lang="scss" scoped>
.view {
  position: relative;
  padding-top: 100px;
  background-color: $primary;

  &-content {
    position: relative;
    .container {
      padding: 0 20px 60px;
    }
    &-title {
        @include margin(null null 10px);
    }
    &-text {
        @include margin(null null 20px);
    }

    .btn {
        @include font('primary', 'bold');
        @include margin(null null 30px);
        @include padding(17px 20px 15px);
        position: relative;
        display: inline-block;
        border: 1px solid $tertiary;
        border-radius: 24px;
        outline: none;
        background-color: transparent;
        color: $tertiary;
        font-size: rem(12px);
        line-height: 1;
        text-align: center;
        text-transform: uppercase;
        width: 100%;
        font-size: rem(12px);
        .svg {
            @include position(absolute, 50% 20px null null);
            fill: $secondary;
            transform: translateY(-50%);
        }
    }
  }

  // Loader
  // -----------------------------------------------------------------------------
  .loader {
    @include position(absolute, 50% null null 50%);
    transform: translate(-50%, -50%);
  }
}
</style>
